import React, { useEffect, useState } from 'react';
import { Link, Navigate, Outlet, useParams } from 'react-router-dom';
import { SiteContext } from '../../contexts/SiteContext';
import { api } from '../../lib/api';
import AdminHeader from '../layout/AdminHeader';
import AdminFooter from '../layout/AdminFooter';

export default function AdminShell({t}) {
  const { username, website: slug } = useParams();
  const [state, setState] = useState({ loading: true, website: null, error: '' });

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get(`/websites/resolve/${username}/${slug}`);
        if (!alive) return;
        setState({ loading: false, website: data, error: '' });
      } catch (e) {
        if (!alive) return;
        const code = e?.response?.status;
        setState({
          loading: false,
          website: null,
          error:
            code === 403 ? t('errors.error403') :
            code === 404 ? t('errors.notFound') :
            t('errors.notLoaded'),
        });
      }
    })();
    return () => { alive = false; };
  }, [username, slug]);

  if (state.loading) return <div className="p-6">{t('loading')}</div>;
  if (state.error === 'Forbidden') return <div className="p-6 text-red-600">{t('errors.error403')}</div>;
  if (state.error === 'Not found') return <div className="p-6">{t('errors.notFound')}</div>;
  if (state.error) return <div className="p-6 text-red-600">{state.error}</div>;

  const base = `/${username}/${slug}`;

  return (
    <SiteContext.Provider value={{ website: state.website }}>
      <div className="min-h-screen flex flex-col bg-gray-100">
        <AdminHeader title={state.website?.title || slug} basePath={base} />
        <main className="flex-1 p-6 min-[50vh]:">
          <Outlet />
        </main>
        <AdminFooter
          faqUrl="/faq"
          gdprUrl="/gdpr"
          privacyUrl="/privacy"
          termsUrl="/terms"
          cookiesUrl="/cookies"
          onManageCookies={() => window.dispatchEvent(new CustomEvent('cookie:open'))}
        />
      </div>
    </SiteContext.Provider>
  );
}

